import { useState } from 'react'
import { IconButton, TableCell, TableRow } from '@mui/material'
import { DeleteIcon } from 'components/Icons'
import { EditIcon } from 'components/Icons'
import Confirm from 'components/Dialog'
import { useDispatch } from 'react-redux'
import { destroy } from 'store/settings/periods'
import dayjs from 'dayjs'
import { Link as NavLink } from 'react-router-dom'
import { useBasePath } from 'components/Providers'
import { useTranslation } from 'react-i18next'

export default function PeriodItem({ period, hasReadWritePermission }) {
  const [confirm, setConfirm] = useState(false)
  const dispatch = useDispatch()
  const basePath = useBasePath()
  const { t } = useTranslation()

  const onConfirm = () => {
    setConfirm(false)
    dispatch(destroy({ id: period.id }))
  }
  
  return (
    <TableRow hover>
      <TableCell>
        {period.name}
      </TableCell>
      <TableCell>
        {' '}
        {period.type === 'course-session' ? t('Course Session') : period.type === 'break' ? t('Break') : t('Lunch')}
      </TableCell>
      <TableCell> {period.affectDaily ? t('Yes') : t('No')}</TableCell>
      <TableCell>
        {' '}
        {dayjs(period.startTime, 'HH:mm:ss').format('h:mm A')} - {dayjs(period.endTime, 'HH:mm:ss').format('h:mm A')}{' '}
      </TableCell>
      <TableCell>
        {' '}
        {dayjs(period.earlyStartTime, 'HH:mm:ss').format('h:mm A')} -{' '}
        {dayjs(period.earlyEndTime, 'HH:mm:ss').format('h:mm A')}{' '}
      </TableCell>
      <TableCell>
        {' '}
        {dayjs(period.delayedStartTime, 'HH:mm:ss').format('h:mm A')} -{' '}
        {dayjs(period.delayedEndTime, 'HH:mm:ss').format('h:mm A')}{' '}
      </TableCell>
      {hasReadWritePermission && (
        <TableCell >
          <IconButton
            aria-label={t('delete')}
            onClick={() => {
              setConfirm(true)
            }}
          >
            <DeleteIcon />
          </IconButton>
          <IconButton component={NavLink} to={`${basePath}/${period.id}`} aria-label={t('edit')}>
            <EditIcon />
          </IconButton>
        </TableCell>
      )}
      <Confirm open={confirm} onClose={() => setConfirm(false)} onConfirm={onConfirm} />
    </TableRow>
  )
}